import { render, staticRenderFns } from "./UserBox.vue?vue&type=template&id=6962f090&"
import script from "./UserBox.vue?vue&type=script&lang=js&"
export * from "./UserBox.vue?vue&type=script&lang=js&"
import style0 from "./UserBox.vue?vue&type=style&index=0&id=6962f090&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports